<template>
  <div>
    <b-modal
      id="changePluginModal"
      ref="changePluginModal"
      hide-footer
      size="lg"
      centered
      @show="onModalShow"
      @hide="onModalHide"
      scrollable
    >
      <template #modal-title>
        <div class="d-flex align-items-center">
          <span>Change Plugin</span>
        </div>
      </template>

      <div class="modal_content">
        <div v-if="!isLoading" style="margin: 20px 0;">
          <label class="font-weight-bold mb-1">Question No</label>

          <b-form-input
            :value="selectedQuestions.map(q => q.questionNo).join(', ')"
            class="w-50 mb-3"
            readonly
          />

          <label for="pluginSelect" class="font-weight-bold mb-1">Select Plugin</label>
          <b-form-select
            id="pluginSelect"
            v-model="selectedPlugin"
            :options="formattedThemes"
            class="w-50"
          />
        </div>


        <div v-else class="text-center" style="min-height: 178px;">
          <b-spinner label="Loading..." medium />
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" :disabled="!selectedPlugin" @click="onSave">
            Save
          </button>
          <button class="btn btn-outline-secondary" @click="onModalHide">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>


 <script>
import { BFormSelect, BModal, BSpinner } from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2";
import { BFormInput } from 'bootstrap-vue';

export default {
  components: {
    BFormSelect,
    BModal,
    BSpinner,
    BFormInput

  },
  props: {
    categoryId: {
    type: [String, Number],
    required: false,
    default: null,
  },
  selectedQuestions: {
    type: Array,
    required: true,
  },
},
  data() {
    return {
      themes: [],
      selectedPlugin: null,
      isLoading: false,
    };
  },
  computed: {
  formattedThemes() {
    return [
      { value: null, text: '-- Choose a Plugin --' }, 
      ...this.themes.map((theme) => ({
        value: theme.plugin,
        text: theme.title,
      })),
    ];
  }

  },
  methods: {
    async onModalShow() {
      this.isLoading = true;
      await this.fetchPlugins();
      this.isLoading = false;
    },
    onModalHide() {
      this.selectedPlugin = null;
      this.$refs.changePluginModal.hide();
    },
    async fetchPlugins() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/plugins/questions/get-all`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        });
        this.themes = res.data.data || [];
      } catch (error) {
        console.error("Error fetching plugins:", error);
      }
    },
    onSave() {
      if (!this.selectedPlugin) return;

      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to change the plugin?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Save it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.savePluginChange();
        }
      });
    },

    async savePluginChange() {
 

  try {
    const response = await axios.post(`${process.env.VUE_APP_API_URL}/change-plugin`, {
      plugin: this.selectedPlugin,
      category_id: this.categoryId,
      question_ids: this.selectedQuestions.map(q => q._id), 
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("_t"),
      }
    });

    Swal.fire("Saved!", "Plugin has been changed for selected questions.", "success");
    this.$refs.changePluginModal.hide();

    this.$emit("pluginChanged", {
      plugin: this.selectedPlugin,
      categoryId: this.categoryId,
      responseData: response.data,
    });

  } catch (error) {
    console.error("Error saving plugin change:", error);
    Swal.fire("Error", "Failed to change plugin.", "error");
  }
}

  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

img.model_backgroundimage {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  height: -webkit-fill-available;
}

.modal_content {
  position: relative;
  z-index: 2;
}

.modal_feedback_data {
  position: relative;
  z-index: 2;
  height: 400px;
}

.highlight-row {
  background: #ff4d4d;
}
</style>

<style>

.modal-actions button {
  margin: 5px;
  /* padding: 12px 24px;
  font-size: 1.2rem;
  border: none;
  border-radius: 4px; */
  cursor: pointer;
}

.save-button {
  background: #32aaed;
  color: white;
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.save-button:disabled {
  background: #32aaed;
  color: #fff;
  opacity: 0.5;
  cursor: not-allowed;
}

.cancel-button {
  background: #f44336;
  color: white;
}

/* .input-field{ */
  .input-field:focus {
    border-color: #32aaed !important;
    box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
    border-width: 1px;
}
/* } */
</style>